import { cx } from '@linaria/core';
import { Fragment } from 'react';
import { getCaptionValue } from '@pm2/content-engine';
import { titleCls, spanCls, captionCls, contentCls } from './atom.slide-caption.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const PUNCTUATION_REGEX = /[.,!?]\s*$/;
function SlideCaption(props) {
  const includeContext = props.inLightbox ? "both" : "in-context";
  const captionModel = {
    caption: getCaptionValue(props.caption?.caption, includeContext),
    title: getCaptionValue(props.caption?.title, includeContext),
    description: getCaptionValue(props.caption?.description, includeContext),
    authorOrArtist: getCaptionValue(props.caption?.authorOrArtist, includeContext),
    country: getCaptionValue(props.caption?.country, includeContext),
    duration: getCaptionValue(props.caption?.duration, includeContext),
    year: getCaptionValue(props.caption?.year, includeContext),
    copyright: getCaptionValue(props.caption?.copyright, includeContext)
  };
  const displayCaption = !!captionModel.caption || !!captionModel.title || !!captionModel.description || !!captionModel.authorOrArtist || !!captionModel.country || !!captionModel.duration || !!captionModel.year || !!captionModel.copyright;
  if (!displayCaption) {
    return /*#__PURE__*/jsx("div", {
      ref: props.ref
    });
  }
  const caption = [captionModel.title && /*#__PURE__*/jsx("span", {
    className: cx(titleCls, spanCls),
    dangerouslySetInnerHTML: {
      __html: captionModel.title
    },
    "data-comma": !PUNCTUATION_REGEX.test(captionModel.title)
  }, "title"), captionModel.description && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: captionModel.description
    },
    "data-comma": !PUNCTUATION_REGEX.test(captionModel.description)
  }, "description"), captionModel.caption && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: captionModel.caption
    },
    "data-comma": !PUNCTUATION_REGEX.test(captionModel.caption)
  }, "caption"), captionModel.authorOrArtist && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: captionModel.authorOrArtist
    },
    "data-comma": !PUNCTUATION_REGEX.test(captionModel.authorOrArtist)
  }, "authorOrArtist"), captionModel.country && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: captionModel.country
    },
    "data-comma": !PUNCTUATION_REGEX.test(captionModel.country)
  }, "country"), captionModel.duration && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: captionModel.duration
    },
    "data-comma": !PUNCTUATION_REGEX.test(captionModel.duration)
  }, "duration"), captionModel.year && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: captionModel.year
    },
    "data-comma": !PUNCTUATION_REGEX.test(captionModel.year)
  }, "year"), captionModel.copyright && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: "©&nbsp;" + captionModel.copyright
    },
    "data-comma": !PUNCTUATION_REGEX.test(captionModel.copyright)
  }, "copyright")].filter(it => !!it);
  return /*#__PURE__*/jsx("span", {
    ref: props.ref,
    className: captionCls,
    children: /*#__PURE__*/jsx("span", {
      className: contentCls,
      children: caption.map((it, index) => /*#__PURE__*/jsxs(Fragment, {
        children: [it, index < caption.length - 1 && (it.props["data-comma"] === true ? ", " : " ")]
      }, index))
    })
  });
}

export { SlideCaption };
//# sourceMappingURL=atom.slide-caption.js.map
